(()=>{
 const setup=root=>{
  root.querySelectorAll('.work-detail__gallery').forEach(gallery=>{
   if(gallery.dataset.modularReady)return;
   gallery.dataset.modularReady='true';
   const items=[...gallery.children];
   const ratio=item=>Number(item.dataset.ratio)||1;
   const groups=[];
   while(items.length){
    const portrait=items.findIndex(item=>ratio(item)<.95);
    const landscapes=items.filter(item=>ratio(item)>=1.15);
    let chosen;
    if(portrait>=0&&landscapes.length>=2&&items.length!==4){
     chosen=[items[portrait],...landscapes.slice(0,2)];
    }else if(items.length>=2){
     chosen=items.splice(0,items.length===3?3:2);
    }else chosen=items.splice(0,1);
    chosen.forEach(item=>{const i=items.indexOf(item);if(i>=0)items.splice(i,1);});
    const row=document.createElement('div');row.className='work-detail__module';
    if(chosen.length===3&&ratio(chosen[0])<.95&&ratio(chosen[1])>=1.15&&ratio(chosen[2])>=1.15){
     row.classList.add('work-detail__module--mixed');
     row.append(chosen[0]);
     const stack=document.createElement('div');stack.className='work-detail__stack';stack.append(...chosen.slice(1));row.append(stack);
     groups.push({row,chosen,mixed:true});
    }else{row.append(...chosen);groups.push({row,chosen,mixed:false});}
    gallery.append(row);
   }
   const layout=()=>groups.forEach(({row,chosen,mixed})=>{
    const gap=parseFloat(getComputedStyle(row).columnGap)||16;
    if(mixed){
     const rp=ratio(chosen[0]);const ra=ratio(chosen[1]);const rb=ratio(chosen[2]);
     const right=(row.clientWidth-gap-rp*gap)/(1+rp*(1/ra+1/rb));
     row.style.gridTemplateColumns=`${Math.max(0,row.clientWidth-gap-right)}px minmax(0,1fr)`;
    }else chosen.forEach(item=>{item.style.flex= `${ratio(item)} 1 0%`;});
   });
   new ResizeObserver(layout).observe(gallery);layout();
  });
  root.querySelectorAll('.work-detail__description p').forEach(p=>{
   if(!p.textContent.trim()&&!p.querySelector('img,video,iframe'))p.remove();
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(document));else setup(document);
 document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
